import React, { useState } from "react";
import Avatar from "react-avatar";
import usePost from "../../customHooks/usePost/UsePost";
import { newUser } from "../../lib/user";
import moment from "moment";

const ChatContainer = ({ selectedUser, messages }) => {
  const [message, setMessage] = useState("");
  const post = usePost();
  // const messages = [
  //   { id: 1, sender: "user", content: "Hello!", timestamp: "10:00 AM" },
  //   { id: 2, sender: "user", content: "How are you?", timestamp: "10:01 AM" },
  //   {
  //     id: 3,
  //     sender: "other",
  //     content: "Hi, I'm good, thank you!",
  //     timestamp: "10:05 AM",
  //   },
  //   // Add more messages as needed
  // ];
  const onSubmit = async (e) => {
    e.preventDefault();
    await post.postData(
      "send-message",
      { message, user_id: newUser?.id, vendor_id: selectedUser?.id },
      () => {
        setMessage("");
        messages?.refetch();
      }
    );
  };
  return (
    <>
      <div
        className={`col-md-8 col-sm-12 ml-0 pl-0 ${
          !selectedUser ? "d-none d-md-block" : ""
        }`}
      >
        <div className="chat-container">
          {selectedUser ? (
            <>
              <div>
                <div className={`border-bottom pb-3 `}>
                  <div className="d-flex ">
                    <div className="d-md-none d-block">
                      {" "}
                      <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>
                    </div>
                    <div>
                      <Avatar name={selectedUser.name} size={30} round="50%" />
                      <span className="ml-2"> {selectedUser.name}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mesages">
                {messages?.data?.data?.map((message) => (
                  <div
                    key={message.id}
                    className={`message-container mt-3 ${
                      message?.user_id === newUser?.id ? "sent" : "received"
                    }`}
                  >
                    <div className="message">{message.message}</div>
                    <div>
                      <small className="timestamp">
                        {moment(message?.created_at).format(
                          "MMM Do, YYYY h:mm A"
                        )}
                      </small>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p>Please select a user to start chatting</p>
          )}
        </div>
        {selectedUser ? (
          <form onSubmit={onSubmit}>
            <div className="input-group mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Type your message..."
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <div className="input-group-append">
                <button className="btn btn-primary" type="submit" t>
                  Send
                </button>
              </div>
            </div>
          </form>
        ) : null}
      </div>{" "}
    </>
  );
};

export default ChatContainer;
